import React from "react";
const AuthenticatingProgress = () => {
    return  <></>;
}


export default AuthenticatingProgress;